import { useState } from "react";
import { apiRequest } from "../../../shared/api/client";
import type { Check } from "./preparation-types";
export function usePreparationExceptionWorkspace({ check, notify, onSaved, }: {
    check: Check;
    notify: (message: string) => void;
    onSaved: (check: Check) => void;
}) {
    const [open, setOpen] = useState(false);
    const [reason, setReason] = useState("");
    const [saving, setSaving] = useState(false);
    const submit = async () => {
        if (reason.trim().length < 10) {
            notify("İstisna gerekçesini en az 10 karakter girin.");
            return;
        }
        setSaving(true);
        try {
            onSaved(await apiRequest<Check>(`/api/material-preparation/checks/${check.id}/status`, {
                method: "POST",
                body: JSON.stringify({
                    status: "EXCEPTION_CLOSED",
                    reason: reason.trim(),
                    override: true,
                    expectedVersion: check.version,
                }),
            }));
            setOpen(false);
            setReason("");
            notify("Gerekçeli istisna denetim kaydıyla kapatıldı.");
        }
        catch (error) {
            notify(error instanceof Error ? error.message : "İstisna kaydedilemedi.");
        }
        finally {
            setSaving(false);
        }
    };
    return { open, setOpen, reason, setReason, saving, submit };
}
